import { render } from "./HomeEightPage.vue?vue&type=template&id=c8f41f30&ts=true"
import script from "./HomeEightPage.vue?vue&type=script&lang=ts"
export * from "./HomeEightPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__